








































































import { HTTP_RESPONSE } from "@/services/Enums";
import { General } from "@/services/General";
import axios from "axios";
import { Component, Vue } from "vue-property-decorator";
import { ChangePasswordDto } from "@/entity/ChangePasswordDto";

@Component
export default class ChangePassword extends Vue {       
    currentPassword: string = null;
    newPassword: string = null;
    confirmPassword: string = null;
    passwordValidationErrors: string = null;
    showCurrentPassword:boolean = false;
    showNewPassword:boolean = false;
    showConfirmPassword:boolean = false;

    loading: boolean = false;
    isSaveClicked: boolean = false;
    confirmPasswordValidationLabel: string = null;

    mounted() {
    }

    confirmPasswordValidation(): boolean {
        if(this.CheckIsNullOrEmpty(this.confirmPassword)) {
            this.confirmPasswordValidationLabel = "Mandatory";
            return false;
        } else if(this.newPassword !== this.confirmPassword) {
            this.confirmPasswordValidationLabel = "Password fields must match";
            return false;
        }
        return true;
    }

    getMessage(data: any) {        
        switch (data.response) {
            case HTTP_RESPONSE.LoginFailed:
                let msg = 'Login failed';
                if (data.message != null && data.message != "") msg = msg + " - " + data.message;
                return msg;
            case HTTP_RESPONSE.UserDoesntExist:
                return 'User doesn\'t exist';
            case HTTP_RESPONSE.UserLockedOut:
                return 'User is now blocked, too many incorrect attempts. Use "Forgot Password" link to reset your password.';
            case HTTP_RESPONSE.InternalUser:
                return 'Inserted Username / e-mail match a PLI domain account. If you forgot your PLI credentials, please open a ticket on MyRequest.';
        }
        return 'Error code: ' + data.response;
    }

    async changePassword() {          
        this.isSaveClicked = true;
        if(this.isValidForm() && this.confirmPasswordValidation()) {
            try {
                this.loading = true; 
                let changePassword = new ChangePasswordDto();
                changePassword.newPassword = this.newPassword;
                changePassword.username = this.$store.state.user.Username;
                changePassword.currentPassword = this.currentPassword;

                let response:any = await axios({
                    method: 'post',
                    url: General.GetApiUrl('/api/auth/ChangePassword'),
                    data: changePassword,
                    withCredentials: true,
                    responseType: 'json'
                });

                if (response.data.response == HTTP_RESPONSE.OK) {
                    this.$emit('onChangePasswordSuccess');
                    General.showAlertSuccess('Password successfully updated.', this);
                } else if(response.data.response == HTTP_RESPONSE.BadRequest) {
                    this.setPasswordValidationError(response.data.passwordValidationError);
                } else {
                    this.$fire({
                        text: this.getMessage(response.data),
                        type: "error"
                    });
                }

                this.loading = false;
                this.isSaveClicked = false;
            } catch (error) {
                this.loading = false;
                General.showAlertDanger(error, this);
            }
        }
    }

    setPasswordValidationError(validationErrors: Array<string>) {
        if(validationErrors != null && validationErrors.length > 0) {
            this.passwordValidationErrors = "<ul>"
            validationErrors.forEach(element => {
                this.passwordValidationErrors += "<li>" + element + "</li>"
            });
            this.passwordValidationErrors += "</ul>"
        }
    }

    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }

    isValidForm() {
        let isValid: boolean = true;
        if(this.CheckIsNullOrEmpty(this.newPassword)
            || this.CheckIsNullOrEmpty(this.confirmPassword)
            || this.CheckIsNullOrEmpty(this.currentPassword)) {
            isValid = false;
        }
        return isValid
    }
    
    CheckIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text.toString() === '') return true;
        return false;
    }
}
